import { useTranslation } from 'react-i18next';
import PhonePendingVerificationIcon from '@/shared/assets/phone-pending-verification-icon.svg?react';
import PhoneSuccessVerificationIcon from '@/shared/assets/phone-success-verification-icon.svg?react';
import { useMemo } from 'react';

interface PhoneVerificationContentProps {
  isSuccess?: boolean;
}

export const PhoneVerificationContent = ({
  isSuccess,
}: PhoneVerificationContentProps) => {
  const { t } = useTranslation();

  const { icon, title, description } = useMemo(() => {
    return {
      icon: isSuccess
        ? PhoneSuccessVerificationIcon
        : PhonePendingVerificationIcon,
      title: t(
        `phoneVerificationModal.${isSuccess ? 'successTitle' : 'pendingTitle'}`
      ),
      description: t(
        `phoneVerificationModal.${isSuccess ? 'successDescription' : 'pendingDescription'}`
      ),
    };
  }, [isSuccess]);

  const IconComponent = icon;

  return (
    <div className="w-full flex flex-col items-center justify-center h-[17.2rem] gap-[2.4rem]">
      <IconComponent />
      <span className="headline4 text-center w-full gap-[0.8rem] flex flex-col">
        {title}
        <p className="p4 text-center text-secondary">{description}</p>
      </span>
    </div>
  );
};
